import { render } from "./ageSelector.vue?vue&type=template&id=6e2c35fe&ts=true"
import script from "./ageSelector.vue?vue&type=script&lang=ts"
export * from "./ageSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__